<template>
	<div id="d21-checkout">
		<div class="d21-block">
			<ValidationObserver ref="observer" v-slot="{ passes }">
				<form @submit.prevent="passes(() => { })" autocomplete="disabled" onkeydown="return event.key != 'Enter';">
					<div class="mdl-grid d21-checkout-text">
						<label class="text-header">
							{{ T("OneTicketing_personal_data") }}
						</label>
						<template v-if="Channel.Content.CheckOutCoronaHint &&
							Channel.Content.CheckOutCoronaHint.IsActive
						">
							<label class="d21-text" v-clean-html="hint"></label>
						</template>
						<div v-if="Reservation.Mode === 'TimeSlots' || Channel.Fields.IsOnlyBuyer
						" class="mdl-cell mdl-cell--4-col mdl-cell--6-col-m form-group">
							<label>{{ T("firstname") }}
								<span class="label-required" v-if="rules('Firstname').required">*</span></label>
							<ValidationProvider name="firstname" :rules="rules('Firstname')" v-slot="{ errors }">
								<input v-model.trim="Reservation.ProfileInfos.Shipping.Givenname" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="given-name" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div v-if="Reservation.Mode === 'TimeSlots' || Channel.Fields.IsOnlyBuyer
						" class="mdl-cell mdl-cell--4-col mdl-cell--6-col-m form-group">
							<label>{{ T("lastname") }}
								<span class="label-required" v-if="rules('Lastname').required">*</span></label>
							<ValidationProvider name="lastname" :rules="rules('Lastname')" v-slot="{ errors }">
								<input v-model.trim="Reservation.ProfileInfos.Shipping.Lastname" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="family-name" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div v-if="Channel.Fields.IsOnlyBuyer" class="mdl-cell mdl-cell--4-col mdl-m--hidden">
							&nbsp;
						</div>
						<div v-if="Reservation.Mode === 'TimeSlots'" class="mdl-cell mdl-cell--3-col mdl-m--hidden">
							&nbsp;
						</div>
						<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group">
							<label>{{ T("email")
								}}<span class="label-required" v-if="rules('Email').required">*</span></label>
							<ValidationProvider name="email" :rules="rules('Email')" v-slot="{ errors }">
								<input v-model.trim="Reservation.ProfileInfos.Shipping.Communication.Email
									" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="email" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group">
							<label>{{ T("repeat_email")
								}}<span class="label-required" v-if="rules('Repeat_Email').required">*</span></label>
							<ValidationProvider name="repeat_email" :rules="rules('Repeat_Email')" v-slot="{ errors }">
								<input v-model.trim="Reservation.ProfileInfos.Shipping.Communication.EmailRepeat
									" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="email" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--3-col mdl-m--hidden">&nbsp;</div>
						<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group" v-if="isFieldActive(Channel.Fields.Phone)">
							<label>{{ T("phone")
								}}<span class="label-required" v-if="rules('Phone').required">*</span></label>
							<ValidationProvider name="phone" :rules="rules('Phone')" v-slot="{ errors }">
								<input v-model="Reservation.ProfileInfos.Shipping.Communication.Phone
									" class="mdl-textfield__input" data-lpignore="true" autocomplete="tel" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--8-col mdl-m--hidden">&nbsp;</div>
						<div class="mdl-cell mdl-cell--8-col mdl-cell--12-col-m form-group" v-if="isFieldActive(Channel.Fields.AddressLine1)">
							<label>{{ T("street_and_street_number")
								}}<span class="label-required" v-if="rules('AddressLine1').required">*</span></label>
							<ValidationProvider name="street_and_street_number" :rules="rules('AddressLine1')" v-slot="{ errors }">
								<input v-model.trim="Reservation.ProfileInfos.Shipping.Address.AddressLine1
									" @keyup="removeUnallowedCharacters" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="shipping street-address" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--3-col mdl-m--hidden">&nbsp;</div>
						<div class="mdl-row mdl-cell mdl-cell--3-col mdl-cell--5-col-m form-group" v-if="isFieldActive(Channel.Fields.PostalCode)">
							<label>{{ T("Address.ZIP")
								}}<span class="label-required" v-if="rules('PostalCode').required">*</span></label>
							<ValidationProvider name="Address.ZIP" ref="postalCode" :rules="rules('PostalCode')" v-slot="{ errors }">
								<input v-model="Reservation.ProfileInfos.Shipping.Address.PostalCode" @input="getPostalCodeSuggestion($event, -1)" @blur="showPostalCodeSuggestions = false" type="number" class="mdl-textfield__input" data-lpignore="true" ref="postalCodeInput" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
							<div v-if="isPostalCodeListShown && idOfShownSuggestions == -1" class="d21-search-input">
								<Loader />
								<ul v-if="!isLoadingPostalCodes" class="top-0">
									<li v-for="(suggestion, index) in postalcodeSuggestions" :key="index" @mousedown="selectPostalCode(suggestion, $event)">
										{{ suggestion.PostalCode + " , " + suggestion.Name }}
									</li>
								</ul>
							</div>
						</div>
						<div class="mdl-cell mdl-cell--5-col mdl-cell--7-col-m form-group" v-if="isFieldActive(Channel.Fields.City)">
							<label>{{ T("location")
								}}<span class="label-required" v-if="rules('City').required">*</span></label>
							<ValidationProvider name="location" :rules="rules('City')" v-slot="{ errors }">
								<input v-model="Reservation.ProfileInfos.Shipping.Address.City" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="shipping locality" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="d21-product mdl-grid mdl-cell mdl-cell--12-col" v-if="Channel.Type === 'Services'">
							<div class="d21-product-text d21-services">
								{{
									formatDate(
										Reservation.Query.From.Date,
										Reservation.Query.From.Minutes,
										Reservation.Query.Until.Minutes
								)
								}}
								<span v-if="Channel._oid !== 123748 || totalSum > 0">{{ T("sum") }}: {{ formatPrice(totalSum, Channel) }}</span>
							</div>
						</div>
						<template v-if="Reservation.MultiDate.IsActive">
							<div class="d21-product mdl-grid mdl-cell mdl-cell--12-col">
								<ProductSet :hasExtendedTravelerData="hasExtendedTravelerData" :channel="Channel" />
							</div>
						</template>
						<template v-else v-for="(product, pIndex) in productsPerUnit">
							<div v-for="(tariff, tariffIndex) in getValidTariffs(product)" class="d21-product mdl-grid mdl-cell mdl-cell--12-col" :key="pIndex + '_' + tariffIndex">
								<div class="d21-product-text" v-if="Channel.Type === 'Services'">
									<i class="material-icons">confirmation_number</i>
									<div class="d21-product-text-name">
										{{ tariff.Count }} x
										{{
											Reservation.fn.getProduct(product.Product).Content.Name
										}}
									</div>
									<div class="d21-product mdl-grid mdl-cell mdl-cell--12-col" v-if="productQuestions.length > 0">
										<template v-for="(question, iQuestion) in productQuestions">
											<div :key="'question_' + iQuestion" class="fullWidth" v-if="question.productUUID === Reservation.fn.getProduct(product.Product)._uuid">
												<label class="text-header">
													{{ question.Questions.Header }}
													<span class="label-required" v-if="question.Questions.IsRequired">*</span>
												</label>
												<div class="mdl-cell mdl-cell--12-col" v-if="question.Questions.IsRequired">
													<ValidationProvider rules="required" v-slot="{ errors }">
														<input :name="'answer' + iQuestion" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('answer')" v-model="question.Questions.Answer" />
														<span class="error" v-if="errors[0]">{{ T("OneTicketing_Please_Answer") }}</span>
													</ValidationProvider>
												</div>
												<div class="mdl-cell mdl-cell--12-col" v-else>
													<input :name="'answer' + iQuestion" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('answer')" v-model="question.Questions.Answer" />
												</div>
											</div>
										</template>
									</div>
									<div class="d21-product-text-sum mdl-m--hidden" v-if="Channel._oid !== 123748 || tariff.Total > 0">
										{{ getDuration(tariff, product) }}|
										{{ formatPrice(tariff.Count * tariff.Total, Channel) }}
									</div>
									<div class="d21-product-text-sum mdl-m--hidden" v-else>
										{{ getDuration(tariff, product) }}
									</div>
									<div class="d21-product-documents" v-if="product.Documents && product.Documents.length > 0">
										{{ T("ticketing_required") }}
										<ul>
											<li v-for="(document, dIndex) in product.Documents" :key="document._uuid">
												<input type="checkbox" :name="'document_' + pIndex + '_' + dIndex" />{{ document.Content.Name }}
												<a v-if="document.URI !== null" :href="'https://api-default.tocc.dirs21.de/v1/cdn' +
													document.URI
													" target="imprint">{{ T("Download") }}</a>
											</li>
										</ul>
									</div>
								</div>
								<div class="d21-product-text" v-else>
									<i class="material-icons">confirmation_number</i>
									<div class="d21-product-text-name">
										{{ tariff.Count }} x
										{{
											Reservation.fn.getProduct(product.Product).Content.Name
										}}
										à {{ formatPrice(tariff.Total) }}
										<template v-if="false && Reservation.EventDate !== null">
											<br />{{ Reservation.EventDate.Content.Name }}
										</template>
									</div>
									<div class="d21-product mdl-grid mdl-cell mdl-cell--12-col" v-if="productQuestions.length > 0">
										<template v-for="(question, iQuestion) in productQuestions">
											<div :key="'question_' + iQuestion" class="fullWidth" v-if="question.productUUID === Reservation.fn.getProduct(product.Product)._uuid">
												<label class="text-header">
													{{ question.Questions.Header }}
													<span class="label-required" v-if="question.Questions.IsRequired">*</span>
												</label>
												<div class="mdl-cell mdl-cell--12-col" v-if="question.Questions.IsRequired">
													<ValidationProvider rules="required" v-slot="{ errors }">
														<input :name="'answer' + iQuestion" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('answer')" v-model="question.Questions.Answer" />
														<span class="error" v-if="errors[0]">{{ T("OneTicketing_Please_Answer") }}</span>
													</ValidationProvider>
												</div>
												<div class="mdl-cell mdl-cell--12-col" v-else>
													<input :name="'answer' + iQuestion" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('answer')" v-model="question.Questions.Answer" />
												</div>
											</div>
										</template>
									</div>
									<div class="d21-product-text-sum mdl-m--hidden">
										{{
											T("sum") + ": " + formatPrice(tariff.Count * tariff.Total)
										}}
									</div>
									<div class="d21-product-text-date" v-if="isProductDateVisible(product)">
										{{
											T("date") +
											": " +
											formatDate(
												Reservation.Query.From.Date,
												Reservation.Query.From.StartTime
										)
										}}
										<template v-if="selectedTimeFrame">{{
											selectedTimeFrame.subText
											}}</template>
									</div>
								</div>
								<template v-if="!Channel.Fields.IsOnlyBuyer">
									<div v-for="(occupancy, oIndex) in tariff.Occupancy" :key="'traveler_' + pIndex + '_' + oIndex" class="d21-product-person mdl-grid mdl-cell mdl-cell--12-col">
										<div class="mdl-cell mdl-cell--4-col mdl-cell--6-col-m form-group d21-firstname">
											<ValidationProvider :rules="rules('Firstname')" v-slot="{ errors }">
												<input :name="'firstname'" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('firstname')" v-model="occupancy.Person.Givenname" />
												<span class="error" v-if="errors[0]">{{
													errors[0]
													}}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--4-col mdl-cell--6-col-m form-group">
											<ValidationProvider :rules="rules('Lastname')" v-slot="{ errors }">
												<input :name="'lastname'" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('lastname')" v-model="occupancy.Person.Lastname" />
												<span class="error" v-if="errors[0]">{{
													errors[0]
													}}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group" v-if="hasExtendedTravelerData">
											<div class="travelerExtended">
												<input type="checkbox" v-model="occupancy.hasExtendedData" :id="`traveler_extended_${pIndex}_${oIndex}`" /><label :for="`traveler_extended_${pIndex}_${oIndex}`">{{ T("different_email_address") }}</label>
											</div>
										</div>
										<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group" v-if="isSameTravelerDataVisible(tariff, oIndex, pIndex)">
											<div class="travelerExtended">
												<input type="checkbox" v-model="occupancy.hasSameTravelerData" @click="toggleSameTravelerData(occupancy)" :id="`traveler_same_${pIndex}_${oIndex}`" /><label :for="`traveler_same_${pIndex}_${oIndex}`">Daten überall gleich</label>
											</div>
										</div>
										<div class="mdl-cell mdl-cell--8-col mdl-cell--12-col-m form-group" v-if="occupancy.hasExtendedData &&
											isFieldActive(Channel.Fields.TravelerEmail)
										">
											<ValidationProvider name="email_" :rules="rules('TravelerEmail')" v-slot="{ errors }">
												<input name="email_deviant" type="email" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('email')" v-model.trim="occupancy.Person.Communication.Email" autocomplete="off" />
												<span class="error" v-if="errors[0]">{{
													errors[0]
													}}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--4-col hide-on-mobile form-group">
											&nbsp;
										</div>
										<div class="mdl-cell mdl-cell--8-col mdl-cell--12-col-m form-group" v-if="occupancy.hasExtendedData &&
											isFieldActive(Channel.Fields.TravelerAddress)
										">
											<ValidationProvider :rules="rules('TravelerAddress')" v-slot="{ errors }">
												<input name="street_and_street_number" type="text" class="mdl-textfield__input" @keyup="removeUnallowedCharacters" data-lpignore="true" :placeholder="T('street_and_street_number')" v-model.trim="occupancy.Person.Address" autocomplete="off" />
												<span class="error" v-if="errors[0]">{{
													errors[0]
													}}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--4-col hide-on-mobile form-group">
											&nbsp;
										</div>
										<div class="mdl-cell mdl-cell--2-col mdl-cell--4-col-m form-group" v-if="occupancy.hasExtendedData &&
											isFieldActive(Channel.Fields.TravelerPostalCode)
										">
											<ValidationProvider :rules="rules('TravelerPostalCode')" v-slot="{ errors }">
												<input name="Address.ZIP" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('Address.ZIP')" v-model="occupancy.Person.PostalCode" autocomplete="off" />
												<span class="error" v-if="errors[0]">{{
													errors[0]
													}}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--6-col mdl-cell--8-col-m form-group" v-if="occupancy.hasExtendedData &&
											isFieldActive(Channel.Fields.TravelerCity)
										">
											<ValidationProvider :rules="rules('TravelerCity')" v-slot="{ errors }">
												<input name="location" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('location')" v-model="occupancy.Person.City" autocomplete="off" />
												<span class="error" v-if="errors[0]">{{
													errors[0]
													}}</span>
											</ValidationProvider>
										</div>
									</div>
								</template>
							</div>
						</template>
					</div>
					<div v-if="Reservation.ProfileInfos.CustomAddressLine && Reservation.ProfileInfos.CustomAddressLine.length > 0">
						<div class="mdl-grid d21-checkout-text" v-for="(address, addressIx) in Reservation.ProfileInfos.CustomAddressLine" :key="addressIx">
							<div class="text-header">
								<label>
									{{ address.Name }}
									<span class="label-required" v-if="isAddressRequired(addressIx)">*</span>
								</label>
							</div>
							<div class="mdl-cell mdl-cell--13-col mdl-cell--6-col-m form-group">
								<label>{{ T("street_and_street_number") }}</label>
								<ValidationProvider :name="'street_and_street_number' + addressIx" :rules="rules('AddressLine1', `CustomAddressLine.${addressIx}`)" v-slot="{ errors }">
									<input v-model.trim="address.AddressLine" @keyup="removeUnallowedCharacters" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="shipping street-address" />
									<span class="error">{{ errors[0] }}</span>
								</ValidationProvider>
							</div>
							<div class="mdl-cell mdl-cell--13-col mdl-cell--6-col-m form-group">
								<label>{{ T("Address.ZIP") }}</label>
								<ValidationProvider :name="'Address.ZIP' + addressIx" ref="postalCode" :rules="rules('address.PostalCode', `CustomAddressLine.${addressIx}`)" v-slot="{ errors }">
									<input v-model="address.PostalCode" @input="getPostalCodeSuggestion($event, addressIx)" @blur="showPostalCodeSuggestions = false" type="number" class="mdl-textfield__input" data-lpignore="true" ref="postalCodeInput" />
									<span class="error">{{ errors[0] }}</span>
								</ValidationProvider>
								<div v-if="isPostalCodeListShown && idOfShownSuggestions == addressIx" class="d21-search-input">
									<Loader />
									<ul v-if="!isLoadingPostalCodes" class="top-0">
										<li v-for="(suggestion, index) in postalcodeSuggestions" :key="index" @mousedown="selectPostalCodeAdditional(suggestion, addressIx, $event)">
											{{ suggestion.PostalCode + " , " + suggestion.Name }}
										</li>
									</ul>
								</div>
							</div>
							<div class="mdl-cell mdl-cell--13-col mdl-cell--6-col-m form-group">
								<label>{{ T("location") }}</label>
								<ValidationProvider :name="'location' + addressIx" :rules="rules('address.City', `CustomAddressLine.${addressIx}`)" v-slot="{ errors }">
									<input v-model="address.City" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="shipping locality" />
									<span class="error">{{ errors[0] }}</span>
								</ValidationProvider>
							</div>
						</div>
					</div>
					<div class="mdl-grid" v-if="isShowChannelQuestions || Reservation.fn.getSelectedProducts().length > 1">
						<template v-for="(question, iQuestion) in Channel.Questions">
							<div :key="'question_' + iQuestion" class="fullWidth">
								<label class="text-header">
									{{ question.Header }}
									<span class="label-required" v-if="question.IsRequired">*</span>
								</label>
								<div class="mdl-cell mdl-cell--12-col" v-if="question.IsRequired">
									<ValidationProvider rules="required" v-slot="{ errors }">
										<input :name="'answer' + iQuestion" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('answer')" v-model="question.Answer" />
										<span class="error" v-if="errors[0]">{{
											T("OneTicketing_Please_Answer")
											}}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--12-col" v-else>
									<input :name="'answer' + iQuestion" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('answer')" v-model="question.Answer" />
								</div>
							</div>
						</template>
					</div>
					<div class="mdl-grid" v-if="totalSum > 0 && paymentMethods.length > 1">
						<label class="text-header">
							{{ T("payment_method") }}
						</label>
						<div class="mdl-cell mdl-cell--12-col">
							<div id="d21-checkout-toggle">
								<div class="d21-switch-container">
									<d21-switcher :items="paymentMethods" v-on:input="selectPaymentMethod"></d21-switcher>
								</div>
							</div>
						</div>
					</div>
					<div class="mdl-grid" v-if="totalSum > 0 && paymentMethods.length === 1">
						<label class="text-header">
							{{ T("ticketing_payment") }}
						</label>
						<div v-if="paymentMethods[0].value === 'Sepa'">
							{{ T("OneTicketing_pay_by_EC-Card_debit") }}
						</div>
						<div v-if="paymentMethods[0].value === 'Sepa' && Channel._oid === 120729
						">
							{{
								T("OneTicketing_pay_by_EC-Card_debit_within_the_next_few_days")
							}}<br />
							{{ T("OneTicketing_BankReturnFees") }}
						</div>
						<div v-if="paymentMethods[0].value === 'Paypal'">
							{{ T("ticketing_paypal") }}
						</div>
						<div v-if="paymentMethods[0].value === 'Cash'">
							{{ T("onsite") }}
						</div>
						<div v-if="paymentMethods[0].value === 'CreditCard'">
							{{ T("OneTicketing_pay_by_credit_card") }}
						</div>
						<div v-if="paymentMethods[0].value === 'Klarna'">
							{{ T("ticketing_klarna") }}
						</div>
					</div>
					<div class="d21-klarna">
						<div id="klarna-payments-container"></div>
					</div>
					<div class="mdl-grid" v-if="Channel.Mode !== 'TimeSlots'">
						<label class="text-header">
							{{ T("Whats_next") }}
						</label>
						<div v-if="Channel.Content && Channel.Content.CheckOutHint" v-clean-html="V(Channel, 'Content.CheckOutHint')"></div>
						<div v-else-if="Channel._oid === 120968">
							{{ T("OneTicketing_TicketSales_are_online_only") }}
						</div>
						<div v-else-if="Channel._oid === 120712 ||
							Channel._oid === 120699 ||
							Channel._oid === 120714 ||
							Channel._oid === 120717 ||
							Channel._oid === 120729 ||
							Channel._oid === 121040
						">
							{{
								T(
									"OneTicketing_InfoText_bookedTicketsCantBeCancelledOrExchanged"
								)
							}}
						</div>
						<div v-else-if="Channel._oid === 120744 || Channel._oid === 121185">
							{{ T("OneTicketing_NoRefundAndExchangePossible") }}
						</div>
						<div v-else-if="Channel._oid === 120721">
							{{
								T(
									"OneTicketing_InfoText_bookedTicketsCantBeCancelledOrExchanged"
								)
							}}<br />
							{{
								T(
									"OneTicketing_all_guests_on_the_same_ticket_enter_at_the_same_time"
								)
							}}
						</div>
						<div v-else-if="Channel.Mode !== 'Services'">
							{{ T("OneTicketing_Tickets_will_be_sent_by_mail") }}<br />
							{{ T("OneTicketing_print_out_tickets_or_redeem_via_smartphone") }}
						</div>
					</div>
					<div class="mdl-grid">
						<div class="text-header" v-if="Channel.Terms && Channel.Terms.IsActive">
							{{ T("accept_terms") }}
						</div>
						<div class="text-header" v-if="!Channel.Terms || !Channel.Terms.IsActive">
							{{ T("data_terms") }}
						</div>
						<div class="d21-terms mdl-cell mdl-cell--12-col">
							<template v-if="validTerms.length > 0">
								<template v-for="(term, iTerm) in validTerms">
									<ValidationProvider :name="term.Name" rules="requiredCb" v-slot="{ errors }" :key="'terms_' + iTerm">
										<input v-model="term.isAccepted" type="checkbox" :name="'term_' + iTerm" value="terms" :id="'term_' + iTerm" />
										<label :for="'term_' + iTerm">{{ V(Channel, `Terms.Items[${iTerm}].Text`) }}<span v-if="term.File">: <a target="_blank" :href="'https://api-default.tocc.dirs21.de/v1/cdn' + term.File.URI">{{ T("view_here") }}</a></span></label>
										<span class="errors"><template v-if="errors.length > 0">{{ T("OneTicketing_Please_Accept") + " " + T("terms") }}</template></span>
									</ValidationProvider>
								</template>
							</template>
							<ValidationProvider :name="Channel.Terms.Name" rules="requiredCb" v-slot="{ errors }" v-else-if="Channel.Terms && Channel.Terms.IsActive && Channel.Terms.Name
							">
								<input v-model="Reservation.Query.IsTermsAccepted" type="checkbox" name="terms" value="terms" id="cb_terms" /><label for="cb_terms">{{
									T("accept_privacy_registration_start") +
									" " +
									Channel.Terms.Name
									}}:
									<a target="_blank" :href="'https://api-default.tocc.dirs21.de/v1/cdn' +
										Channel.Terms.File.URI
										">{{ T("view_here") }}</a>
								</label>
								<span class="errors">{{ errors[0] }}</span>
							</ValidationProvider>
							<ValidationProvider name="Hygiene_and_bathing_rules" rules="requiredCb" v-slot="{ errors }" v-else-if="Channel.Terms &&
								Channel.Terms.IsActive &&
								Channel._oid !== 120968 &&
								Channel._oid !== 121153
							">
								<input v-model="Reservation.Query.IsTermsAccepted" type="checkbox" name="terms" value="terms" id="cb_terms" /><label for="cb_terms">{{
									T("accept_privacy_registration_start") +
									" " +
									T("Hygiene_and_bathing_rules")
									}}:
									<a target="_blank" :href="'/terms/' + Channel._oid + '/terms.pdf'">{{ T("view_here") }}</a>
								</label>
								<span class="errors">{{ errors[0] }}</span>
							</ValidationProvider>
							<ValidationProvider name="Hygiene_rules" rules="requiredCb" v-slot="{ errors }" v-else-if="Channel.Terms &&
								Channel.Terms.IsActive &&
								Channel._oid === 120968
							">
								<input v-model="Reservation.Query.IsTermsAccepted" type="checkbox" name="terms" value="terms" id="cb_terms" /><label for="cb_terms">{{
									T("accept_privacy_registration_start") +
									" " +
									T("Hygiene_rules")
									}}:
									<a target="_blank" :href="'/terms/' + Channel._oid + '/terms.pdf'">{{ T("view_here") }}</a>
								</label>
								<span class="errors">{{ errors[0] }}</span>
							</ValidationProvider>
							<ValidationProvider name="important_info_for_viewers" rules="requiredCb" v-slot="{ errors }" v-else-if="Channel.Terms &&
								Channel.Terms.IsActive &&
								Channel._oid === 121153
							">
								<input v-model="Reservation.Query.IsTermsAccepted" type="checkbox" name="terms" value="terms" id="cb_terms" /><label for="cb_terms">{{
									T("accept_privacy_registration_start") +
									" " +
									T("important_info_for_viewers")
									}}:
									<a target="_blank" :href="'/terms/' + Channel._oid + '/terms.pdf'">{{ T("view_here") }}</a>
								</label>
								<span class="errors">{{ errors[0] }}</span>
							</ValidationProvider>
							<ValidationProvider name="data_terms" rules="requiredCb" v-slot="{ errors }">
								<input v-model="Reservation.Query.IsGdprAccepted" type="checkbox" name="gdpr" value="gdpr" id="cb_gdpr" /><label for="cb_gdpr">{{
									T("accept_privacy_registration_start") +
									" " +
									T("data_terms")
									}}:
									<a target="_blank" :href="privacyPolicyLink">{{
										T("view_here")
										}}</a></label>
								<span class="errors">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
					</div>
					<BottomNav>
						<div class="mdl-m--hidden" v-if="$route.query && $route.query.referrer">
							<button class="btn btn-primary" @click="close">
								<span>{{ T("cancel") }}</span>
							</button>
						</div>
						<div class="d21-sum">
							<template v-if="Channel._oid !== 123748 || totalSum > 0">
								{{ T("sum") }}: {{ formatPrice(totalSum) }}
							</template>
						</div>
						<div class="d21-next">
							<Button text="Finalize_booking" v-if="totalSum === 0" @click="passes(next)" isPrimary :isLoading="isLoading" />
							<div class="d21-next-paypal" v-else-if="Reservation.Payment.Method === 'Paypal'">
								<label>{{ T("Finalize_booking_and_pay") }}</label>
								<div id="paypal-button"></div>
							</div>
							<Button text="Finalize_booking_and_pay" mobileText="Finalize_booking" isPrimary v-else-if="isKlarnaOrCreditCardOrSepaSelected" @click="passes(next)" :isLoading="isLoading" />
							<Button text="Finalize_booking_with_payment" isPrimary v-else-if="Reservation.Payment.Method === 'Cash'" @click="passes(next)" :isLoading="isLoading" />
						</div>
					</BottomNav>
				</form>
			</ValidationObserver>

			<Modal name="checkout.sepa" :title="T('Enter_BankDetails')" :actions="sepaModalActions">
				<div class="mdl-grid">
					<div class="mdl-cell mdl-cell--12-col">
						{{ T("Payee") }}: {{ Channel.Payment.Sepa.Recipient }}<br />
						{{ T("sepa_creditorid") }}: {{ Channel.Payment.Sepa.CreditorID
						}}<br /><br />
						{{ T("I_hereby_revocably_authorize_you") }}:
					</div>
					<template v-if="Profile.Payment &&
						Profile.Payment.Sepa &&
						isPaymentSepaFromProfile
					">
						<div class="mdl-cell mdl-cell--12-col">
							<div class="mdl-grid d21-product">
								<div class="mdl-cell mdl-cell--12-col form-group">
									<span class="singleLine">{{ T("owner") }}: {{ Profile.Payment.Sepa.Owner }}</span>
								</div>
								<div class="mdl-cell mdl-cell--12-col form-group">
									<span class="singleLine">{{ T("iban") }}: {{ Profile.Payment.Sepa.IBAN }}</span>
								</div>
								<div class="mdl-cell mdl-cell--12-col form-group" v-if="Profile.Payment.Sepa.BIC">
									<span class="singleLine">{{ T("bic") }}: {{ Profile.Payment.Sepa.BIC }}</span>
								</div>
								<div class="mdl-cell mdl-cell--12-col form-group">
									<button class="btn btn-black-outline btn-small f-right" @click="isPaymentSepaFromProfile = false">
										<span>{{ T("edit") }}</span>
									</button>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="mdl-cell mdl-cell--12-col form-group">
							<input v-model="Reservation.Payment.Sepa.Owner" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('account_holder')" />
							<span class="error" v-if="isOwnerInvalid">{{
								T("PleaseEnter_AccountHolder")
								}}</span>
							<span class="error" v-if="isOwnerCharactersInvalid">{{
								T("No_accented_arabic_characters_allowed")
								}}</span>
						</div>
						<div class="mdl-cell mdl-cell--12-col form-group">
							<input v-model="Reservation.Payment.Sepa.Iban" type="text" class="mdl-textfield__input" data-lpignore="true" placeholder="IBAN" />
							<span class="error" v-if="!ibanIsInvalid && isIbanInvalid">{{
								T("enter_iban")
								}}</span>
							<span class="error" v-else-if="!ibanIsInvalid && isIbanCountryInvalid">{{ T("payment_direct_debit_countries") }}:
								{{ allowedCountries }}.</span>
							<span class="error" v-else-if="ibanIsInvalid">{{
								T("check_iban")
								}}</span>
						</div>
						<div class="mdl-cell mdl-cell--12-col form-group" v-if="hub.countryFromIban(this.Reservation.Payment.Sepa.Iban) !==
							'Deutschland'
						">
							<input v-model="Reservation.Payment.Sepa.BIC" type="text" class="mdl-textfield__input" data-lpignore="true" placeholder="BIC" />
							<span class="error" v-if="bicIsInvalid">{{
								T("check_bic")
								}}</span>
						</div>
						<div v-if="hasProfilePayment" class="mdl-cell mdl-cell--12-col form-group">
							<button class="btn btn-black-outline btn-small f-right" @click="isPaymentSepaFromProfile = true">
								<span>{{ T("cancel") }}</span>
							</button>
						</div>
					</template>
					<div class="mdl-cell mdl-cell--12-col">
						<br />
						<i><b>{{ T("SEPA_direct_debit_mandate") }}</b><br />
							{{
								T("I_authorize_you_to_collect_payments_start") +
								" " +
								Channel.Address.LocalAuthority.Name +
								" " +
								T("I_authorize_you_to_collect_payments_end")
							}}
							<br /><br />
							{{ T("refund_request_note") }}</i>
					</div>
					<Loader />
				</div>
			</Modal>

			<Modal name="checkout.credit-card" :title="T('payment_simple')" :actions="creditCardModalActions">
				<iframe height="750" :src="creditCardUrl"></iframe>
			</Modal>

			<Modal name="checkout.validation" :title="T('errors_occured_during_booking')" :actions="validationModalActions">
				<div class="mdl-grid">
					<div class="mdl-cell mdl-cell--12-col">
						<ul>
							<li v-for="error in validation.errors" :key="error" class="error">
								{{ error }}
							</li>
						</ul>
					</div>
				</div>
			</Modal>
		</div>
	</div>
</template>

<script>
	import _hub from "../scripts/_hub";
	import _default from "../mixins/default";
	import baseMixin from "../mixins/base";
	import api from "../scripts/_api";
	import {
		EventBus
	} from "../scripts/_eventBus.js";
	import {
		email,
		is,
		min,
		alpha_spaces,
		alpha_dash,
		regex,
		max,
	} from "vee-validate/dist/rules";
	import Loader from "./ui/loader.vue";
	import BottomNav from "./ui/bottom-nav.vue";
	import Button from "./ui/button.vue";
	import Variables from "../scripts/_variables.js";
	import {
		ValidationProvider,
		ValidationObserver,
		extend
	} from "vee-validate";
	import Modal from "./modal.vue";
	import ProductSet from "./partial/checkout-productset.vue";
	import payment from "../mixins/payment.js";
	import helpers from "@/scripts/_helpers";

	export default {
		mixins: [baseMixin, _default, payment],
		name: "d21-checkout",
		components: {
			Loader,
			ValidationProvider,
			ValidationObserver,
			ProductSet,
			BottomNav,
			Button,
			Modal,
		},
		computed: {
			sepaModalActions() {
				return [{
						text: this.T("cancel"),
						onClick: () => {
							this.$modals.hide("checkout.sepa");
						},
					},
					{
						text: this.T("pay"),
						onClick: () => {
							this.book();
						},
						isPrimary: true,
					},
				];
			},
			creditCardModalActions() {
				return [{
					text: this.T("close"),
					onClick: () => {
						this.$modals.hide("checkout.credit-card");
					},
					isPrimary: true,
				}, ];
			},
			validationModalActions() {
				return [{
					text: this.T("close"),
					onClick: () => {
						this.$modals.hide("checkout.validation");
					},
					isPrimary: true,
				}, ];
			},
			validTerms() {
				if (this.Channel.Terms && this.Channel.Terms.Items && this.Channel.Terms.Items.length > 0) {
					return this.Channel.Terms.Items;
				}
				return [];
			},
			hint() {
				//display Hint Text
				let note = this.T("OneTicketing_ChainOfInfectionNote_start");
				if (
					this.Channel.Content &&
					this.Channel.Content.CheckOutCoronaHint &&
					this.Channel.Content.CheckOutCoronaHint.Text
				) {
					return this.V(this.Channel, "Content.CheckOutCoronaHint.Text");
				} else if (this.Channel.Mode === "Dates") {
					note += this.T("spectator");
				} else if (this.Channel.Mode === "TimeSlots") {
					note += this.T("customer");
				} else {
					note += this.T("Guest");
				}
				return note + this.T("OneTicketing_ChainOfInfectionNote_end");
			},
			modalWidth() {
				return this.isMobile ? "90%" : "700";
			},
			bicIsInvalid() {
				return (
					this.hub.countryFromIban(this.Reservation.Payment.Sepa.Iban) !==
					"Deutschland" &&
					(this.Reservation.Payment.Sepa.BIC === null ||
						this.Reservation.Payment.Sepa.BIC === "")
				);
			},
			isIbanInvalid() {
				if (!this.isPosted || this.Reservation.Payment.Method !== "Sepa")
					return false;
				return this.ibanIsInvalid || this.Reservation.Payment.Sepa.Iban === null;
			},
			hasExtendedTravelerData() {
				return (
					this.isFieldActive(this.Channel.Fields.TravelerEmail) ||
					this.isFieldActive(this.Channel.Fields.TravelAddress) ||
					this.isFieldActive(this.Channel.Fields.TravelerPostalCode) ||
					this.isFieldActive(this.Channel.Fields.TravelerCity)
				);
			},
			hasSameTravelerData() {
				return this.Channel.Type === "Services";
			},
			allowedCountries() {
				if (
					!this.Channel.Payment.Sepa.AllowedCountries ||
					this.Channel.Payment.Sepa.AllowedCountries.length === 0 ||
					this.Channel.Payment.Sepa.AllowedCountries.indexOf("Alle") !== -1
				) {
					return "";
				} else {
					var countries = "";
					this.Channel.Payment.Sepa.AllowedCountries.forEach(
						(c) => (countries += ", " + c)
					);
					return countries.substring(2);
				}
			},
			isIbanCountryInvalid() {
				if (
					this.Reservation.Payment.Sepa.Iban !== null &&
					this.Channel.Payment.Sepa.AllowedCountries &&
					this.Channel.Payment.Sepa.AllowedCountries.length > 0 &&
					this.Channel.Payment.Sepa.AllowedCountries.indexOf("Alle") === -1
				) {
					var country = this.hub.countryFromIban(
						this.Reservation.Payment.Sepa.Iban
					);
					return (
						this.Channel.Payment.Sepa.AllowedCountries.indexOf(country) === -1
					);
				} else {
					return false;
				}
			},
			isOwnerInvalid() {
				if (!this.isPosted || this.Reservation.Payment.Method !== "Sepa")
					return false;
				return (
					this.Reservation.Payment.Sepa.Owner === null ||
					this.Reservation.Payment.Sepa.Owner.length < 5
				);
			},
			isOwnerCharactersInvalid() {
				var pattern = "[^A-Za-z':?,\\-\\ (+.ÄäßÖöÜü)/]";
				return (
					this.Reservation.Payment.Sepa.Owner !== null &&
					this.Reservation.Payment.Sepa.Owner.match(pattern)
				);
			},
			isPostalCodeListShown() {
				return (
					(this.postalcodeSuggestions || this.isLoadingPostalCodes) &&
					this.showPostalCodeSuggestions
				);
			},
			isKlarnaOrCreditCardOrSepaSelected() {
				return (
					this.isPaymentMethodSelected("CreditCard") ||
					this.isPaymentMethodSelected("Klarna") ||
					this.isPaymentMethodSelected("Sepa")
				);
			},
			hasProfilePayment() {
				return this.Profile.Payment;
			},
			productsPerUnit() {
				var products = this.Reservation.ProductsPerUnit;
				// I don't know why we have the following code, but this breaks the summary for events.
				if (
					this.Channel.Fields.IsOnlyBuyer &&
					this.Reservation.Mode !== "Dates"
				) {
					const count = {};
					this.Reservation.Products.forEach((p) => {
						count[p.Product] = (count[p.Product] || 0) + 1;
					});
					products = [
						...this.Reservation.Products.reduce(
							(map, obj) => map.set(obj.Product, obj),
							new Map()
						).values(),
					];
					// reassign Count of each product if no customer info needed.
					Object.keys(count).forEach((key) => {
						if (count[key] > 1) {
							products
								.filter((p) => p.Product == key)
								.forEach((product) => {
									product.Tariffs.forEach((tariff) => {
										tariff.Count = count[key];
									});
								});
						}
					});
				}
				return products;
			},
		},
		data() {
			return {
				creditCardUrl: null,
				data: null,
				ibanIsInvalid: false,
				isPosted: false,
				isLoading: false,
				isLoadingPostalCodes: false,
				isPaymentSepaFromProfile: false,
				isSaving: false,
				privacyPolicyLink: null,
				postalcodeSuggestions: null,
				showPostalCodeSuggestions: false,
				shouldInsertSpaces: true,
				Variables: Variables,
				validation: {
					errors: [],
				},
				idOfShownSuggestions: -2,
				isShowChannelQuestions: false,
				productQuestions: []
			};
		},
		created: function () {
			//
			const apiPromises = [];
			if (this.Reservation.fn.getSelectedProducts().length) {
				this.Reservation.fn.getSelectedProducts().forEach((p) => {
					const command = `/settings/questions/${p.Product}`;
					const apiPromise = new Promise((resolve, reject) => {
						this.apiRequest(command, null, "GET", ({
							Value
						}) => {
							if (this.Reservation.fn.getSelectedProducts().length === 1) {
								this.isShowChannelQuestions = Value.IsChannelQuestions;
							}

							// As Default ChannelQuestions always to show
							// Value.IsChannelQuestions is nullabel value
							this.isShowChannelQuestions = Value.IsChannelQuestions == null ? true : Value.IsChannelQuestions;

							if (Value && Value.QuestionsList) {
								Value.QuestionsList.forEach((i) => {
									if (!this.productQuestions.some(question => question._uuid === i._uuid)) {
										this.productQuestions.push({
											"Questions": i,
											"productUUID": p.Product
										});
									}
								});
							}
							resolve();
						});
					});
					apiPromises.push(apiPromise);
				});
			}
			//
			if (this.Channel.Questions) {
				this.Reservation.Questions = [];
				this.Channel.Questions.forEach((q, ix) => {
					const header = this.V(this.Channel, `Questions[${ix}].Header`);
					this.Reservation.Questions.push({
						Header: header,
						Answer: q.Answer,
						IsRequired: q.IsRequired,
					});
				});
			}
			if (this.Channel.Fields.CustomAddressLine) {
				//rebind in case cache has still fields
				this.Reservation.ProfileInfos.CustomAddressLine = [];

				this.Channel.Fields.CustomAddressLine.forEach((addr, addrIx) => {
					const name = this.V(this.Channel, `Fields.CustomAddressLine[${addrIx}].Name`);
					this.Reservation.ProfileInfos.CustomAddressLine.push({
						Name: name,
						AddressLine: null,
						City: null,
						PostalCode: null
					})
				});
			}

			if (_hub.culture === "de-DE")
				this.privacyPolicyLink = "/OBT_ Datenschutz _DE_TOS.pdf";
			else this.privacyPolicyLink = "/OBT_PrivacyPolicy_EN_TOS.pdf";

			//
			EventBus.$on("result_onSelected", () => {
				this.data = {};
			});
			EventBus.$on("onPostMesssage", this.onPostMesssage);

			extend("alpha_spaces_dash", {
				...alpha_spaces,
				key: "{_field_}",
				validate(value) {
					return /^[A-Za-zÀ-ÿ\-'\s]+$/i.test(value);
				},
				message: (key) => {
					return `${this.T('oneticketing_field_not_valid').replace('{0}', this.T(key))}`;
				}
			});
			extend("alpha_spaces", alpha_spaces);
			extend("email", email);
			extend("min", {
				...min,
				key: '{_field_}',
				message: (key, min) => {
					var name = this.T(key);
					return `${this.T('oneticketing_field_length').replace(/{\d}/g, (ix) => {return {'{0}': name, '{1}': min.length}[ix]})}`;
				}
			});
			extend("max", max);
			extend("regex", {
				...regex,
				key: '{_feld_}',
				message: (key) => {
					return `${this.T('oneticketing_field_not_valid').replace('{0}', this.T(key))}`
				}
			});

			//
			this.Reservation.fn.createProductsPerUnit();

			//
			this.setProfileData();

			//
			if (this.paymentMethods.length === 1) {
				this.paymentMethods[0].isSelected = true;
				this.selectPaymentMethod(this.paymentMethods[0]);
			} else if (this.Reservation.Payment.Method === "Paypal") {
				this.initPaypal();
			} else if (this.Reservation.Payment.Method === "Klarna") {
				let interval = window.setInterval(() => {
					if (this.isKlarnaReady) {
						this.klarna();
						window.clearInterval(interval);
					}
				});
			}
		},
		methods: {
			isAddressRequired(ix) {
				if (!this.Channel.Fields.CustomAddressLine || !this.Channel.Fields.CustomAddressLine[ix]) return false;
				return this.Channel.Fields.CustomAddressLine[ix].IsRequired;
			},
			isSameTravelerDataVisible(tariff, oIndex, pIndex) {
				return (
					(this.Reservation.ProductsPerUnit.length > 1 ||
						tariff.Occupancy.length > 1) &&
					pIndex === 0 &&
					oIndex === 0 &&
					this.hasSameTravelerData
				);
			},
			isProductDateVisible(product) {
				return (
					(!this.Reservation.EventDate ||
						!this.Reservation.EventDate.Type ||
						this.Reservation.EventDate.Type !== "AlwaysAvailableProduct") &&
					this.Reservation.fn.getProduct(product.Product).Settings
					.ScheduleType !== "Seasonal"
				);
			},
			editPaymentSepa() {
				this.isPaymentSepaFromProfile = true;
			},
			getValidTariffs(product) {
				return product.Tariffs.filter((t) => t.Count > 0);
			},
			async deleteBlockedCapacities() {
				return new Promise((resolve, reject) => {
					if (!this.Reservation._temp || !this.Reservation._temp.token) {
						resolve();
						return;
					}

					const command = `BlockedCapacities/Token/${this.Reservation._temp.token}`;
					api.delete(command, (response) => {
						if (response.Value) {
							// do nothing.
						}
						// resolve also on error - doesn't matter if we get success or not
						resolve();
					});
				});
			},
			setProfileData() {
				if (this.Profile && this.Profile.Contact.GivenName) {
					this.Reservation.ProfileInfos.Token = this.Profile.Token;
					this.Reservation.ProfileInfos.Shipping.Givenname =
						this.Profile.Contact.GivenName;
					this.Reservation.ProfileInfos.Shipping.Lastname =
						this.Profile.Contact.LastName;
					this.Reservation.ProfileInfos.Shipping.Communication.Email =
						this.Profile.Contact.Email;
					this.Reservation.ProfileInfos.Shipping.Communication.EmailRepeat =
						this.Profile.Contact.Email;
					this.Reservation.ProfileInfos.Shipping.Communication.Phone =
						this.Profile.Contact.Mobile;
					this.Reservation.ProfileInfos.Shipping.Address.AddressLine1 =
						this.Profile.Contact.Street;
					this.Reservation.ProfileInfos.Shipping.Address.PostalCode =
						this.Profile.Contact.PostalCode;
					this.Reservation.ProfileInfos.Shipping.Address.City =
						this.Profile.Contact.City;
					if (
						this.Reservation.ProductsPerUnit &&
						this.Reservation.ProductsPerUnit.length > 0
					) {
						this.Reservation.ProductsPerUnit[0].Tariffs[0].Occupancy[0].Person.Givenname =
							this.Profile.Contact.GivenName;
						this.Reservation.ProductsPerUnit[0].Tariffs[0].Occupancy[0].Person.Lastname =
							this.Profile.Contact.LastName;
					}
					if (this.Profile.Payment && this.Profile.Payment.Sepa) {
						this.isPaymentSepaFromProfile = true;
					}
				}
			},
			removeUnallowedCharacters(e) {
				e.target.value = e.target.value.replaceAll(
					/[^A-zÀ-ü0-9 \\+/.:,#&-]/g,
					""
				);
			},
			rules(field, customPath) {
				const rules = {};
				const path = customPath || field;
				const targetObj = helpers.fn.findValue(this.Channel.Fields, path)
				if (targetObj) {
					rules.required = targetObj.IsRequired;
				}

				switch (field) {
					case "Repeat_Email":
						rules.required = true;
						rules.email = true;
						rules.emailConfirm = "@email";
						break;
					case "Email":
						rules.required = true;
						rules.email = true;
						break;
					case "Firstname":
					case "Lastname":
						if (!this.Channel.Fields.IsOnlyBuyer) break;
						rules.required = true;
						rules.min = 2;
						rules.alpha_spaces_dash = true;
						break;
					case "Phone":
						rules.min = 6;
						rules.regex = /^[+]?(\d+([ /-]\d+)*)$/;


						break;
					case "AddressLine1":
					case "TravelerAddress":
						rules.regex = /[a-zA-Z0-9.]+\s\d/;
						rules.min = 5;
						break;
					case "TravelerEmail":
						rules.email = true;
						break;
					default:
						break;
				}
				return rules;
			},
			// Select Suggestion
			selectPostalCode(selectedAddress, event) {
				// set values from address
				this.Reservation.ProfileInfos.Shipping.Address.PostalCode =
					selectedAddress.PostalCode;
				this.Reservation.ProfileInfos.Shipping.Address.City =
					selectedAddress.Name;
				// reset
				this.postalcodeSuggestions = null;
			},
			selectPostalCodeAdditional(selectedAddress, index, event) {
				// set values from address
				this.Reservation.ProfileInfos.CustomAddressLine[index].PostalCode =
					selectedAddress.PostalCode;
				this.Reservation.ProfileInfos.CustomAddressLine[index].City =
					selectedAddress.Name;
				// reset
				this.postalcodeSuggestions = null;
			},
			// Set Custome Validation Error Message for Inputs
			setCustomValidationResult(ref, key = null) {
				this.$refs[ref].applyResult({
					errors: [this.T(key)],
					valid: true,
					failedRules: {},
				});
			},
			getDuration(tariff, product) {
				let output = "";
				if (tariff.Count * product.Selling.Duration <= 0) return " 0 min ";
				if (this.getDays(tariff, product) > 0)
					output += this.getDays(tariff, product) + " d ";
				if (this.getPartialHours(tariff, product) > 0)
					output += this.getPartialHours(tariff, product) + " h ";
				if (this.getPartialMinutes(tariff, product) > 0)
					output += this.getPartialMinutes(tariff, product) + " min ";

				return output;
			},
			getPartialMinutes(tariff, product) {
				return (tariff.Count * product.Selling.Duration) % 60;
			},
			getPartialHours(tariff, product) {
				return Math.floor((tariff.Count * product.Selling.Duration) / 60) % 24;
			},
			getDays(tariff, product) {
				return Math.floor((tariff.Count * product.Selling.Duration) / 1440);
			},
			// Get Postal Code Suggestions
			getPostalCodeSuggestion(event, idOfShownSuggestions) {
				if(this.Channel._oid === 132519) return;
				//
				this.isLoadingPostalCodes = true;
				EventBus.$emit("postalcode_loading_start");
				if (this.postalCodeTimeoutId) {
					window.clearTimeout(this.postalCodeTimeoutId);
				}

				this.postalCodeTimeoutId = window.setTimeout(() => {
					// set input value
					const value = event.target.value;
					if (value.length > 0) {
						var culture = this.hub.culture;
						var command = `/checkout/cities?postalCode=${value}&culture=${culture}`;
						this.apiRequest(command, null, "GET", (result) => {
							if (result.Meta && result.Meta.IsValid) {
								const cities = result.Value;
								const n = cities.length;
								if (n > 0) {
									this.idOfShownSuggestions = idOfShownSuggestions;
									this.showPostalCodeSuggestions = true;
									this.postalcodeSuggestions = cities;
								} else {
									// set error message when no result is null
									this.setCustomValidationResult(
										"postalCode",
										"postal_code_not_found"
									);
									this.postalcodeSuggestions = null;
								}
							} else {
								// set error message when no result is null
								this.setCustomValidationResult(
									"postalCode",
									"postal_code_not_found"
								);
								this.postalcodeSuggestions = null;
							}
						});
						EventBus.$emit("postalcode_loading_end");
						this.isLoadingPostalCodes = false;
					} else {
						EventBus.$emit("postalcode_loading_end");
						this.isLoadingPostalCodes = false;
					}
				}, 250);
			},

			next() {
				if (this.totalSum === 0) {
					this.Reservation.Payment.Method = "Free";
					this.book();
				} else if (this.Reservation.Payment.Method === "Sepa") {
					this.$modals.show("checkout.sepa");
				} else if (this.Reservation.Payment.Method === "CreditCard") {
					this.isLoading = true;

					this.serverValidate(() => {
						const reservation = this.Reservation.fn.get();

						this.preauth(reservation)
							.then((url) => {
								this.isLoading = false;
								this.creditCardUrl =
									url || this.Reservation._Payment.URLs.Redirect;
								this.$modals.show("checkout.credit-card");
							})
							.catch((result) => {
								this.isLoading = false;
								this.validation.errors = result.Value.Errors;
								this.$modals.show("checkout.validation");
								EventBus.$emit("loading_end");
							});
					});
				} else if (this.Reservation.Payment.Method === "Klarna") {
					this.isLoading = true;

					this.serverValidate(() => {
						const reservation = this.Reservation.fn.get();

						this.klarnaAuthorize(reservation)
							.then((res) => {
								console.log(res);
								//
								this.preauth(res).then(() => {
									this.book();
								});
							})
							.catch((result) => {
								this.isLoading = false;
								this.validation.errors = result.Value.Errors;
								this.$modals.show("checkout.validation");
								EventBus.$emit("loading_end");
							});
					});
				} else {
					this.book();
				}
			},
			serverValidate(cb) {
				var command = `/book/${this.Channel.Directory}/validate`;
				var reservation = this.Reservation.fn.get();
				this.apiRequest(command, reservation, "POST", (result) => {
					if (result.Meta && result.Meta.IsValid && result.Value.IsValid) {
						cb();
					} else {
						this.isLoading = false;
						this.validation.errors = result.Value.Errors;
						this.$modals.show("checkout.validation");
						EventBus.$emit("loading_end");
					}
				});
			},
			book() {
				//
				this.isLoading = true;
				this.isPosted = true;
				this.isSaving = true;
				setTimeout(() => {
					if (!this.isSaving) {
						this.validate(this.saveReservation);
						this.shouldInsertSpaces = true;
					}
				}, 100);
			},
			async saveReservation(cb) {
				var reservation = this.Reservation.fn.get(this.isNewPayment);

				var command = `/book/${this.Channel.Directory}`;
				this.errorMessage = null;
				if (reservation.Mode === "Ticket") reservation.Mode = "Shifts";
				await this.deleteBlockedCapacities();
				this.apiRequest(command, reservation, "POST", (result) => {
					if (result.Meta && result.Meta.IsValid && result.Value.IsValid) {
						this.validation.errors = [];
						this.$router.replace({
							name: "confirmation",
						});
						window.setTimeout(() => {
							EventBus.$emit("checkout_onAfterBook", result.Value);
							EventBus.$emit("loading_end");
						}, 100);
					} else {
						this.isLoading = false;
						if (result.Value && result.Value.Validation.Errors) {
							this.validation.errors = result.Value.Validation.Errors;
							this.$modals.show("checkout.validation");
						} else {
							this.validation.errors = [result.Meta.Message];
						}
						EventBus.$emit("loading_end");
					}
				});
			},
			validate(cb) {
				this.ibanIsInvalid = false;
				if (!this.isPaymentSepaFromProfile) {
					if (
						this.totalSum === 0 ||
						(!this.isOwnerInvalid &&
							!this.isOwnerCharactersInvalid &&
							!this.isIBANInvalid &&
							!this.isIbanCountryInvalid &&
							!this.bicIsInvalid)
					) {
						// validate iban
						if (this.totalSum > 0 && this.Reservation.Payment.Method === "Sepa") {
							var command = `/validation/${this.Channel.Directory}/iban/${this.Reservation.Payment.Sepa.Iban}`;
							this.apiRequest(
								command,
								null,
								"GET",
								(result) => {
									if (result.Meta && result.Meta.IsValid && result.Value) {
										cb();
									} else {
										this.ibanIsInvalid = true;
										this.isLoading = false;
									}
								},
								(err) => {
									this.isLoading = false;
									this.validation.errors = [this.T("book_failed_unknown_error")];
									this.$modals.show("checkout.validation");
								}
							);
						} else {
							cb();
						}
					} else {
						this.isLoading = false;
					}
				} else {
					// assign profile payment details
					this.Reservation.Payment.Sepa = this.Profile.Payment.Sepa;
					cb();
				}
			},
			tryGetProductDescription(reservation, product) {
				try {
					if (reservation.Mode === "Services") {
						return this.formatDate(
							reservation.From.Date,
							reservation.From.TimeFrame.Times.Start,
							reservation.From.TimeFrame.Times.End
						);
					}
					return this.tryFormatRange(product.Period.From, product.Period.Until);
				} catch (err) {
					return null;
				}
			},
			close() {
				parent.postMessage({
						type: "d21-close-overlay",
					},
					"*"
				);
			},
			isFieldActive(field) {
				return field && (field.IsVisible || field.IsRequired);
			},
			toggleSameTravelerData(occupancy) {
				if (!occupancy.hasSameTravelerData) {
					var givenname = "";
					var lastname = "";
					this.Reservation.ProductsPerUnit.flatMap((c) => c.Tariffs).forEach(
						(p, px) => {
							p.Occupancy.forEach((o, ox) => {
								if (px == 0 && ox == 0) {
									givenname = o.Person.Givenname;
									lastname = o.Person.Lastname;
								} else {
									o.Person.Givenname = givenname;
									o.Person.Lastname = lastname;
								}
							});
						}
					);
				}
			},
		},
		watch: {
			isLoading(newValue) {
				EventBus.$emit(newValue ? "loading_start" : "loading_end");
			},
			// insert spaces when entering a new IBAN
			"Reservation.Payment.Sepa.Iban": {
				handler(newValue) {
					if (this.shouldInsertSpaces) {
						this.Reservation.Payment.Sepa.Iban = newValue
							.replace(/[^\dA-Z]/g, "")
							.replace(/(.{4})/g, "$1 ")
							.trim();
					}
					// delete BIC when the BIC field is not visible
					if (
						this.hub.countryFromIban(this.Reservation.Payment.Sepa.Iban) ===
						"Deutschland"
					) {
						this.Reservation.Payment.Sepa.BIC = "";
					}
				},
			},
			// delete spaces in IBAN when saving
			isSaving: {
				handler(newValue) {
					if (newValue) {
						this.shouldInsertSpaces = false;
						if (
							this.Reservation.Payment.Sepa.Iban != null &&
							this.Reservation.Payment.Sepa.Iban.includes(" ")
						) {
							this.Reservation.Payment.Sepa.Iban =
								this.Reservation.Payment.Sepa.Iban.replace(/ /g, "");
						}
						this.isSaving = false;
					}
				},
			},
			productQuestions: {
				handler(newQuestions) {
					newQuestions.forEach((question, iQuestion) => {
						const existingQuestion = this.Reservation.Questions.find(q => q.Header === question.Questions.Header);
						if (existingQuestion) {
							existingQuestion.Answer = question.Questions.Answer;
						} else {
							this.Reservation.Questions.push({
								Header: question.Questions.Header,
								Answer: question.Questions.Answer,
								IsRequired: question.Questions.IsRequired,
							});
						}
					})
				},
				deep: true,
			},
			"Channel.Questions": {
				handler(newQuestions) {
					newQuestions.forEach((question, iQuestion) => {
						const existingQuestion = this.Reservation.Questions.find(q => q.Header === question.Header);
						if (existingQuestion) {
							existingQuestion.Answer = question.Answer;
						} else {
							this.Reservation.Questions.push({
								Header: question.Header,
								Answer: question.Answer,
								IsRequired: question.IsRequired,
							});
						}
					})
				},
				deep: true,
			},
		},
	};
</script>